export { default } from './Forum.component';
